import React from 'react'
import { render } from 'react-dom'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import './Quill.css'

const insertFunction = {
  data: function insertCustomTags(args) {
    const value = args
    const cursorPosition = this.quill.getSelection().index
    this.quill.insertText(cursorPosition, value)
    this.quill.setSelection(cursorPosition + value.length)
  },
}

const CustomToolbar2 = (index, data) => {
  return (
    <div id={`toolbar${index.index}`}>
      <select className='ql-font'>
        <option value='arial' selected>
          Arial
        </option>
        <option value='comic-sans'>Comic Sans</option>
        <option value='courier-new'>Courier New</option>
        <option value='georgia'>Georgia</option>
        <option value='helvetica'>Helvetica</option>
        <option value='lucida'>Lucida</option>
      </select>
      <button class='ql-bold'></button>
      <button class='ql-italic'></button>
      <button class='ql-underline'></button>
      <select className='ql-size'>
        <option value='extra-small'>Size 1</option>
        <option value='small'>Size 2</option>
        <option value='medium' selected>
          Size 3
        </option>
        <option value='large'>Size 4</option>
      </select>
      <span class='ql-formats'>
        <button
          class='ql-list'
          value='ordered'
          ngbPopover='Ordered list'
          triggers='mouseenter:mouseleave'
        ></button>
        <button
          class='ql-list'
          value='bullet'
          ngbPopover='Bulleted list'
          triggers='mouseenter:mouseleave'
        ></button>
      </span>
      <select className='ql-insertCustomTags'>
        {index?.data?.map((key, i) => {
          return <option key={i} value={`{{${key}}}`}>{key}</option>
        })}
      </select>
    </div>
  )
}

export class Editor extends React.Component {
  state = { moduleData: '' }

  handleChange = (html) => {
    // let dataIndex = [...this?.props?.quote?.data]
    // let x = {...dataIndex[this.props.index], content: html}
    // dataIndex?.splice(this.props.index, 1)
    // dataIndex?.splice(this.props.index, 0, x)
    this.props.setQuote(html)
  }

  module = {
    toolbar: {
      container: `#toolbar${this.props.toolName}`,
      handlers: {
        insertCustomTags: insertFunction.data,
      },
    },
  }

  render() {
    return (
      <>
        <CustomToolbar2 index={this.props.toolName} data={this.props.listData} />
        <ReactQuill
          value={this?.props?.quote?.content}
          onChange={this.handleChange}
          placeholder={this.props.placeholder}
          modules={this.module}
        />
      </>
    )
  }
}
